// extracted by mini-css-extract-plugin
export var category = "_jo-9";
export var categoryHeader = "_jo-e";
export var container = "_jo-0";
export var group = "_jo-a";
export var groupItems = "_jo-f";
export var groupSeparator = "_jo-j";
export var loading = "_jo-1";
export var noResults = "_jo-3";
export var placeholder = "_jo-2";
export var resultContent = "_jo-5";
export var resultIcon = "_jo-c";
export var resultItem = "_jo-g";
export var resultMeta = "_jo-8";
export var resultSubtitle = "_jo-7";
export var resultSuffix = "_jo-i";
export var resultTitle = "_jo-6";
export var resultsList = "_jo-4";
export var searchGroup = "_jo-d";
export var selected = "_jo-h";
export var subgroup = "_jo-b";